import './core-js';
import '@formatjs/intl-segmenter/polyfill.js';

import Backbone from 'backbone';
import {enableES5, enableMapSet, setAutoFreeze} from 'immer';
import jquery from 'jquery';

Backbone.$ = jquery;

// Turn off auto-freezing immer objects. Without this, anything we run thru `produce` gets locked.
setAutoFreeze(false);
// We also enable Immer on older browsers
enableES5();
enableMapSet();
